import Navbar from "../componenets/Navbar";
import Sidebar from "../componenets/Sidebar";
import React, { useState } from 'react';
import swal from "sweetalert";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button } from "@mui/material";
import useKawasans from "../componenets/useKawasans";

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://globizsystems.com/';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#596CFF",
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function FailedMessagesTable({ messages }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="failed messages table">
        <TableHead>
          <TableRow>
            <StyledTableCell>ID</StyledTableCell>
            <StyledTableCell>NAMA</StyledTableCell>
            <StyledTableCell align="center">NO. AKAUN AIR</StyledTableCell>
            <StyledTableCell align="center">SENDER NAME</StyledTableCell>
            <StyledTableCell align="center">NO. TELEFON</StyledTableCell>
            <StyledTableCell align="center">CURRENT AMOUNT</StyledTableCell>
            <StyledTableCell align="center">TOTAL DUE AMOUNT</StyledTableCell>
            <StyledTableCell align="center">DUE DATE</StyledTableCell>
            <StyledTableCell align="center">KAWASAN SEWAAN</StyledTableCell>
            <StyledTableCell align="center">FAILED DATE</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {messages?.map((item) => (
            <StyledTableRow key={item.id} id={item.no_akaun_air}>
              <StyledTableCell>{item.id}</StyledTableCell>
              <StyledTableCell>{item.nama}</StyledTableCell>
              <StyledTableCell align="center">{item.no_akaun_air}</StyledTableCell>
              <StyledTableCell align="center">{item.sender_name}</StyledTableCell>
              <StyledTableCell align="center">{item.no_telefon_1}</StyledTableCell>
              <StyledTableCell align="center">{item.current_amount}</StyledTableCell>
              <StyledTableCell align="center">{item.due_amount}</StyledTableCell>
              <StyledTableCell align="center">{item.due_date}</StyledTableCell>
              <StyledTableCell align="center">{item.kawasan_sewaan}</StyledTableCell>
              <StyledTableCell align="center">{item.createdAt}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function FaildMessagesList() {
  const [customers, setCustomers] = useState([]);
  const [area, setArea] = useState([]);
  const [areaLocation, setAreaLocation] = useState('');
  const [script, setScript] = useState('');
  const [isDownloading, setIsDownloading] = useState(false);
  const kawasanOptions = useKawasans('air');

  async function findCustomer(event) {
    const accountNo = event.target.value.trim();

    if (!accountNo) {
      setCustomers([]);
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/messages/get_failed_single_customer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ account_no: accountNo })
      });

      if (!response.ok) throw new Error('Unable to search failed messages.');
      setCustomers(await response.json());
    } catch (error) {
      console.error('Failed-message account search failed:', error);
      setCustomers([]);
    }
  }

  async function findCustomerLocation(event) {
    const kodKawasan = event.target.value;
    setAreaLocation(kodKawasan);

    try {
      const response = await fetch(`${API_BASE_URL}/messages/allfail_messages`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kod_kawasan: kodKawasan })
      });

      if (!response.ok) throw new Error('Unable to load failed messages for this area.');
      setArea(await response.json());
    } catch (error) {
      console.error('Failed-message area search failed:', error);
      setArea([]);
      swal({
        title: 'Unable to load messages',
        text: error.message,
        icon: 'error'
      });
    }
  }

  function findScript(event) {
    setScript(event.target.value);
    setAreaLocation('');
    setArea([]);
  }

  async function downloadFailedMessagesReport() {
    if (!areaLocation) {
      swal({
        title: 'Choose an area first',
        text: 'Select a script and location before downloading the report.',
        icon: 'warning'
      });
      return;
    }

    setIsDownloading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/reports/all_failed_messages_excel`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kod_kawasan: areaLocation })
      });

      if (!response.ok) {
        let message = 'Unable to generate the Excel report.';
        try {
          const errorBody = await response.json();
          message = errorBody.details || errorBody.error || message;
        } catch (error) {
          // The server may return a non-JSON error page.
        }
        throw new Error(message);
      }

      const reportBlob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(reportBlob);
      const link = document.createElement('a');
      const safeAreaName = String(areaLocation)
        .trim()
        .replace(/[^a-zA-Z0-9_-]+/g, '_');

      link.href = downloadUrl;
      link.download = `Failed_Messages_${safeAreaName || 'ALL'}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Failed-message Excel report download failed:', error);
      swal({
        title: 'Download failed',
        text: error.message || 'Unable to generate the Excel report.',
        icon: 'error'
      });
    } finally {
      setIsDownloading(false);
    }
  }

  const selectedKawasans = script === 'penjaja'
    ? kawasanOptions.penjaja
    : kawasanOptions.perumahan;

  return (
    <>
      <Navbar />
      <div className="row">
        <Sidebar />
      </div>
      <main className="main-content position-relative h-100 border-radius-md contained ">
        <div className="container-fluid g-3 ">
          <h4 className="colorfix sizefix mx-2">All Failed Messages</h4>
          <div className="card px-2 pt-3 pb-3 mb-4 cardbg">
            <div className="container-fluid" style={{ backgroundColor: "white" }}>
              <div className="container-fluid px-0 ">
                <div className="col-12">
                  <div className="container-fluid pb-4 pt-3 g-3">
                    <div className="row ">
                      <Box
                        className="row"
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '40ch' } }}
                        noValidate
                        autoComplete="off"
                      >
                        <div className="col-5">
                          <TextField
                            required
                            id="failed-account-search"
                            label="Search failed bills by Account Number"
                            defaultValue=""
                            onChange={findCustomer}
                          />
                        </div>

                        <div className="col-5 mt-2">
                          <FormControl fullWidth>
                            <InputLabel id="failed-script-label">Choose Script</InputLabel>
                            <Select
                              labelId="failed-script-label"
                              id="failed-script"
                              value={script}
                              label="Choose Script"
                              onChange={findScript}
                            >
                              <MenuItem value="penjaja">Penjaja</MenuItem>
                              <MenuItem value="perumahan">Perumahan</MenuItem>
                            </Select>
                          </FormControl>
                        </div>

                        {script && (
                          <div className="col-8 mt-2 mx-2">
                            <FormControl fullWidth>
                              <InputLabel id="failed-location-label">
                                Choose Location ({script === 'penjaja' ? 'Penjaja' : 'Perumahan'})
                              </InputLabel>
                              <Select
                                labelId="failed-location-label"
                                id="failed-location"
                                value={areaLocation}
                                label={`Choose Location (${script === 'penjaja' ? 'Penjaja' : 'Perumahan'})`}
                                onChange={findCustomerLocation}
                              >
                                {selectedKawasans.map((kawasan) => (
                                  <MenuItem key={kawasan.kod_kawasan} value={kawasan.kod_kawasan}>
                                    {kawasan.nama_kawasan}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                        )}
                      </Box>

                      {customers.length > 0 && (
                        <div id="failed-search-table" className="mt-3">
                          <legend><b>All Failed Bills for Customer</b></legend>
                          <FailedMessagesTable messages={customers} />
                        </div>
                      )}

                      <div id="failed-search-table-area" className="mt-4">
                        <legend><b>Total Failed Bills by Area</b></legend>
                        <legend>
                          <Button
                            variant="contained"
                            size="large"
                            onClick={downloadFailedMessagesReport}
                            disabled={!areaLocation || isDownloading}
                          >
                            {isDownloading ? 'Preparing report...' : 'Download Excel Report'}
                          </Button>
                        </legend>
                        <FailedMessagesTable messages={area} />
                      </div>

                      <br className="pt-4" />
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default FaildMessagesList;
